let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eafRu")).then(() => parcelRequire('2xlV5'));